import React from 'react'
import { cn } from '@utils/safeTs'
import { EditorErrorType, EditorImageType } from '@utils/types'
import styles from './EditorImage.module.sass'
import { AlertTriangle, Bin } from '@components/icons'

interface Props {
  image: EditorImageType
  error?: EditorErrorType
  size?: 'medium' | 'small'
  onClose?: () => void
  className?: string
}

const EditorImage = (props: Props) => {
  const { image, error = undefined, size = 'medium', onClose, className = '' } = props

  return image ? (
    <div
      className={cn(
        styles.root,
        size ? styles[`root--${size}`] : undefined,
        error ? styles[`root--${error.variant}`] : undefined,
        className
      )}
    >
      <div className={styles.imageBox}>
        {!!(image?.editorMeta?.preview_image || image?.editorMeta?.image) && (
          <img
            src={`${process.env.NODE_ENV === 'development' ? 'http://localhost:9999' : ''}${
              image?.editorMeta?.preview_image || image?.editorMeta?.image
            }`}
          />
        )}{' '}
        {/* è un svg, non serve next image */}
      </div>
      {!!image.filename && <span className={styles.label}>{image.filename}</span>}
      {error && (
        <span className={styles.infoIcon}>
          <AlertTriangle />
        </span>
      )}
      {!!onClose && (
        <button type="button" onClick={onClose} className={styles.close}>
          <Bin />
        </button>
      )}
    </div>
  ) : (
    <></>
  )
}

export default EditorImage
